// Angular import
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, effect, inject, OnInit, ViewChild, viewChild } from '@angular/core';
import { MatDrawer, MatDrawerContainer, MatDrawerMode } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { ElbuildCoreComponentsModule } from 'elbuild-ui-componentslib';
import { SharedDataService } from 'elbuild-ui-lib-core';
import { BreadcrumbComponent } from 'src/app/@theme/components/breadcrumb/breadcrumb.component';
import { SvgComponent } from 'src/app/@theme/components/svg/svg.component';
import { COMPACT, HORIZONTAL, LTR, RTL, VERTICAL } from 'src/app/@theme/const';
import { ConfigurationComponent } from 'src/app/@theme/layouts/configuration/configuration.component';
import { FooterComponent } from 'src/app/@theme/layouts/footer/footer.component';
import { CompactMenuComponent } from 'src/app/@theme/layouts/menu/compact-menu';
import { HorizontalMenuComponent } from 'src/app/@theme/layouts/menu/horizontal-menu';
import { VerticalMenuComponent } from 'src/app/@theme/layouts/menu/vertical-menu';
import { NavBarComponent } from 'src/app/@theme/layouts/toolbar/toolbar.component';
import { AuthenticationService } from 'src/app/@theme/services/authentication.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { Navigation } from 'src/app/@theme/types/navigation';
import { getConfig } from 'src/app/app-config';
import { environment } from 'src/environments/environment';

import { SharedModule } from '../../../@core/shared/shared.module';
import { BuyNowLinkService } from '../../../@theme/services/buy-now-link.service';
import { getMenu } from '../../data/menu';

// Project import
// service
// const import
// theme version
//type
@Component({
	selector: 'app-admin',
	imports: [
		SharedModule,
		RouterModule,
		CommonModule,
		NavBarComponent,
		VerticalMenuComponent,
		HorizontalMenuComponent,
		CompactMenuComponent,
		BreadcrumbComponent,
		ConfigurationComponent,
		FooterComponent,
		SvgComponent,
		ElbuildCoreComponentsModule
	],
	templateUrl: './admin.component.html',
	styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, AfterViewInit {
	private themeService = inject(ThemeLayoutService);
	buyNowLinkService = inject(BuyNowLinkService);

	@ViewChild(MatDrawerContainer) container!: MatDrawerContainer;

	// public props
	readonly sidebar = viewChild<MatDrawer>('sidebar');
	menus: Navigation[] = getMenu();
	modeValue: MatDrawerMode = 'side';
	direction: string = 'ltr';
	currentApplicationVersion = environment.appVersion;
	logosvg: string | undefined = environment.svglogo;
	logoimage: string | undefined = environment.imagelogo;
	title: string | undefined = environment.title;
	currentLayout: string = 'vertical';
	rtlMode: boolean = false;
	windowWidth: number = window.innerWidth;
	loading: boolean;

	// Constructor
	constructor(private authenticationService: AuthenticationService, private sharedDataService: SharedDataService) {
		effect(() => {
			this.updateThemeLayout(this.themeService.layout());
		});
		effect(() => {
			this.themeDirection(this.themeService.directionChange());
		});
	}

	// life cycle event
	ngOnInit() {
		this.themeService.islargescreen.subscribe(result => {
			if (result) {
				this.modeValue = 'side';
			} else {
				this.modeValue = 'over';
				this.sidebar()!.toggle();
			}
		})
		this.sharedDataService.currentLoading.subscribe(
			loading => setTimeout(() => this.loading = loading)
		);


		/**
		 * Dashboard menu sidebar toggle listener
		 */
		this.themeService.dashBoardMenuState.subscribe(() => {
			this.sidebar()!.toggle();
		});

		/**
		 * current login user role
		 */
		//  const currentUser = this.authenticationService.currentUserValue;
		//  const userRoles = currentUser?.role ? [currentUser.role] : [Role.Admin];

		/**
		 * Role base menu filtering
		 */
		this.menus = getMenu(); //this.RoleBaseFilterMenu(menus, userRoles);
	}

	ngAfterViewInit() {
		this.rtlMode = getConfig().isRtlLayout;

		this.currentLayout = getConfig().layout;
		setTimeout(() => {
			if (this.container) {
				this.container.updateContentMargins();
			}
			this.manageLayout(this.currentLayout);
		}, 1000
		);
	}

	/**
	 * Role base menu filtering
	 */
	/*
	RoleBaseFilterMenu(menus: Navigation[], userRoles: string[], parentRoles: string[] = [Role.Admin]): Navigation[] {
	  return menus.map((item) => {
		// If item doesn't have a specific role, inherit roles from parent
		const itemRoles = item.role ? item.role : parentRoles;
  
		// If item has children, recursively filter them, passing current item's roles as parentRoles
		if (item.children) {
		  item.children = this.RoleBaseFilterMenu(item.children, userRoles, itemRoles);
		}
  
		return item; // Return the item whether it is visible or disabled
	  });
	}*/

	/**
	 * Listen to Theme direction change. RTL/LTR
	 */
	private themeDirection(direction: string) {
		this.rtlMode = direction === RTL ? true : false;
		this.manageLayout(this.currentLayout);
	}

	/**
	 * Listen to theme layout changes
	 */
	private updateThemeLayout(layout: string) {
		this.currentLayout = layout;
		this.manageLayout(layout);
	}

	/**
	 * Manage layout of theme
	 */
	private manageLayout(layout: string) {
		const drawerContent = document.querySelector('.mat-drawer-content') as HTMLElement;
		if (drawerContent) {
			if (layout === VERTICAL) {
				if (this.windowWidth > 1025) {
					drawerContent.style.marginLeft = this.rtlMode === true ? '0px' : '280px';
					drawerContent.style.marginRight = this.rtlMode === true ? '280px' : '0px';
				}
				this.direction = this.rtlMode === true ? RTL : LTR;
			} else if (layout === COMPACT) {
				if (this.windowWidth > 1025) {
					drawerContent.style.marginLeft = this.rtlMode == true ? '0px' : '90px';
					drawerContent.style.marginRight = this.rtlMode == true ? '90px' : '0px';
				}
				this.direction = this.rtlMode == true ? RTL : LTR;
			} else if (layout == HORIZONTAL) {
				drawerContent.style.marginLeft = '0px';
			}
		}
	}

	toggleSideDrawer() {
		this.themeService.toggleSideDrawer();

	}
}
